export enum APIEndpoints {
  Authenticate = '/yki/auth/',
  CountryCodes = '/yki/api/code/maatjavaltiot2',
  ExamSessions = '/yki/api/exam-session',
  ExamSession = '/yki/api/exam-session/:examSessionId',
  ExamSessionQueue = '/yki/api/exam-session/:examSessionId/queue',
  Evaluations = '/yki/api/evaluation',
  Evaluation = '/yki/api/evaluation/:evaluationId',
  EvaluationOrder = '/yki/api/evaluation/:evaluationId/order',
  EvaluationOrderDetails = '/yki/api/evaluation/order/:evaluationOrderId',
  InitRegistration = '/yki/api/registration/init',
  IdentifyRegistration = '/yki/api/registration/identify',
  LanguageCodes = '/yki/api/code/kieli',
  LoginLink = '/yki/api/login-link',
  LoginLinkRenew = '/yki/api/login-link/renew',
  LoginLinkInfo = '/yki/auth/login-link-info',
  LoginWithCode = '/yki/auth/login',
  Logout = '/yki/auth/logout',
  Registration = '/yki/api/registration/:registrationId',
  SubmitRegistration = '/yki/api/registration/:registrationId/submit',
  User = '/yki/api/user/identity',
  OpenRegistrations = '/yki/api/user/open-registrations',
  PersonDetails = '/yki/api/person',
  CancelUserRegistration = '/yki/api/person/registration/:registrationId',
  ConfirmRegistration = '/yki/api/person/registration/:registrationId/confirm',
  RedirectToPayment = '/yki/api/payment/v3/:registrationId/redirect?lang=:lang',
  RedirectToPaymentFromUserPortal = '/yki/api/person/registration/:registrationId/payment-redirect?lang=:lang',
  PublicKoskiEducations = '/yki/api/public/education',
  PublicFreeRegistrationEducation = '/yki/api/public/education/:registrationId',
}

export enum PaymentStatus {
  Success = 'payment-success',
  Cancel = 'payment-cancel',
  Error = 'payment-error',
}
